<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useDropdownContext } from './provider.js';

const props = defineProps({
  label: { type: String, default: '' },
  icon: { type: [String, Object, Function], default: '' },
  link: { type: [String, Object], default: '' },
  nativeLink: { type: Boolean, default: false },
  click: { type: Function, default: null },
  preserveOpen: { type: Boolean, default: false },
});

defineOptions({
  inheritAttrs: false,
});

const { closeMenu } = useDropdownContext();

const componentIs = computed(() => {
  if (props.link) {
    if (props.nativeLink && typeof props.link === 'string') {
      return 'a';
    }

    return 'router-link';
  }
  if (props.click) return 'button';

  return 'div';
});

// BonBoZ: chi gan `href`/`to` cho DUNG loai the dang dung.
//
// Ban goc gan ca hai, cai khong dung thi cho `null`:
//     :href="componentIs === 'a' ? props.link : null"
//     :to="componentIs === 'router-link' ? props.link : null"
// Voi `router-link`, `href: null` van di vao `$attrs` va de len chinh `href`
// ma RouterLink tu dung — ra mot the <a> KHONG CO href. Hau qua: con tro chuot
// thanh dau nhap chu thay vi ban tay, khong mo duoc tab moi, khong copy duoc
// lien ket. Bam van chay vi RouterLink bat su kien click rieng, nen loi nay
// song sot lau: muc "Cai dat ca nhan" trong menu avatar la muc duy nhat dung
// `link` dang doi tuong. Do ngay 11/09/2026.
const thuocTinhLienKet = computed(() => {
  if (componentIs.value === 'a') return { href: props.link };
  if (componentIs.value === 'router-link') return { to: props.link };
  return {};
});

const triggerClick = () => {
  if (props.click) {
    props.click();
  }
  if (!props.preserveOpen) closeMenu();
};
</script>

<template>
  <li class="n-dropdown-item">
    <component
      :is="componentIs"
      v-bind="{ ...$attrs, ...thuocTinhLienKet }"
      class="flex text-left rtl:text-right items-center p-2 reset-base text-sm text-n-slate-12 w-full border-0"
      :class="{
        'hover:bg-n-alpha-2 rounded-lg w-full gap-3': !$slots.default,
      }"
      @click="triggerClick"
    >
      <slot>
        <slot name="icon">
          <Icon v-if="icon" class="size-4 text-n-slate-11" :icon="icon" />
        </slot>
        <slot name="label">{{ label }}</slot>
      </slot>
    </component>
  </li>
</template>
